import { Seo } from '../components/Seo';

export function CookiesPage() {
  return (
    <>
      <Seo
        path="/cookies"
        title="Cookies"
        description="Cookiebeleid ComfortTool™ — functionele opslag van je scan, thema-voorkeur en optionele statistiek."
        keywords="ComfortTool cookies, cookiebeleid, AVG, privacy"
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:py-14 text-ct-text">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Cookiebeleid</h1>
        <div className="mt-8 space-y-6 text-sm leading-relaxed text-ct-muted">
          <p>
            ComfortTool™ gebruikt <strong className="text-ct-text">functionele</strong> opslag op je apparaat om je
            invoer en tussenresultaat te bewaren tussen bezoeken. Zo werken de scan en het printrapport zoals
            bedoeld — je kunt rustig later verdergaan.
          </p>
          <p>
            De cookiebanner laat je kiezen of we <strong className="text-ct-text">optionele statistiek</strong>{' '}
            mogen gebruiken.             In de huidige versie van de site laden we <strong className="text-ct-text">geen</strong> externe
            meetscripts totdat je daarvoor zelf toestemming geeft.
          </p>
          <p>
            Je kunt je keuze wijzigen door de opgeslagen gegevens van deze site te wissen in je browserinstellingen,
            of door hier later opnieuw je voorkeur te bevestigen als we daarvoor een knop toevoegen.
          </p>
          <p className="text-xs text-ct-muted/80">
            Pas deze tekst aan met je concrete trackers en bewaartermijnen zodra je die in productie neemt.
          </p>
        </div>
      </div>
    </>
  );
}
